import dynamic from 'next/dynamic';

import { useShouldHideUserAccountExclusiveContent } from '@/hooks/useShouldHideUserAccountExclusiveContent';
import { useProjectUnits } from '@/hooks/queries/useProjectUnits';
import { useParentProject } from '@/hooks/queries/useParentProject';
import { useListing } from '@/hooks/queries/useListing';

const OtherProjectUnits = dynamic(() =>
  import('@/components/property-expose/OtherProjectUnits/OtherProjectUnits').then((mod) => mod.OtherProjectUnits),
);

export const DynamicOtherProjectsUnits = () => {
  const isUAExclusiveListingAndNotSignedIn = useShouldHideUserAccountExclusiveContent();
  const { data: parentProject } = useParentProject();
  const { data: projectUnitsResponse } = useProjectUnits();
  const {
    data: { listing },
  } = useListing();

  if (!projectUnitsResponse?.listings.length || !parentProject || !listing || isUAExclusiveListingAndNotSignedIn) return null;

  return <OtherProjectUnits projectUnitsResponse={projectUnitsResponse} parentProject={parentProject} />;
};
